/* Enter your Custom Javascript code below without script tag */
// Company name: Developed by TechFanatic 
// Website URL: https://techfanatic.in/


function findWhatsAppLink() {

  console.log("Searching for WhatsApp link...");


  const directSelector = document.querySelector('a[href*="whatsapp.com"]');
  if (directSelector) {
    console.log("Found via direct WhatsApp link selector:", directSelector);
    return directSelector;
  }


  const textLink = Array.from(document.getElementsByTagName('a'))
    .find(a => a.textContent.includes('JOIN OUR COMMUNITY'));
  if (textLink) {
    console.log("Found via text content:", textLink);
    return textLink;
  }


  const classLink = document.querySelector('.btn_text');
  if (classLink) {
    console.log("Found via class selector:", classLink);
    return classLink;
  }

  console.error("No WhatsApp link found using any method");
  return null;
}

window.addEventListener('DOMContentLoaded',function () {

$(".collection-hero__title+.collection-hero__description").insertAfter("#ProductGridContainer .pagination-wrapper");
 
});


findWhatsAppLink();